const VERSION_KEY = 'version'
const RETRY_KEY = 'chunk-load-retry'

function safeGet(storage, key) {
  try { return storage.getItem(key) } catch (e) { return null }
}

function safeSet(storage, key, value) {
  try { storage.setItem(key, value) } catch (e) { /* storage may be disabled */ }
}

export function runStartupVersionGuard(version) {
  const previous = safeGet(window.localStorage, VERSION_KEY)
  if (previous === version) return

  // Keep authentication and navigation context. Only obsolete version markers are replaced.
  safeSet(window.localStorage, VERSION_KEY, version)
  try { window.sessionStorage.removeItem(RETRY_KEY) } catch (e) { /* ignore */ }
}

export function installChunkLoadRecovery() {
  window.addEventListener('error', event => {
    const message = event && event.message ? event.message : ''
    const isChunkError = /ChunkLoadError|Loading chunk [\w-]+ failed|\.js\b.*failed/i.test(message)
    if (!isChunkError) return

    const retried = safeGet(window.sessionStorage, RETRY_KEY)
    if (retried === '1') return
    safeSet(window.sessionStorage, RETRY_KEY, '1')
    window.location.reload()
  })
}
